// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vc-8";
export var editMode = "_vc-3";
export var headerRow = "_vc-a";
export var headerTitle = "_vc-b";
export var product = "_vc-1";
export var productDetails = "_vc-5";
export var productDivider = "_vc-7";
export var productImage = "_vc-2";
export var productInfo = "_vc-4";
export var productTitle = "_vc-6";
export var strikethrough = "_vc-9";
export var upsellProductsCard = "_vc-0";